function RecordingIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19 13V5C19 3.34315 17.6569 2 16 2C14.3431 2 13 3.34315 13 5V13C13 14.6569 14.3431 16 16 16C17.6569 16 19 14.6569 19 13ZM16 0C13.2386 0 11 2.23858 11 5V13C11 15.7614 13.2386 18 16 18C18.7614 18 21 15.7614 21 13V5C21 2.23858 18.7614 0 16 0Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7 10C7.55228 10 8 10.4477 8 11V13C8 17.4183 11.5817 21 16 21C20.4183 21 24 17.4183 24 13V11C24 10.4477 24.4477 10 25 10C25.5523 10 26 10.4477 26 11V13C26 18.5228 21.5228 23 16 23C10.4772 23 6 18.5228 6 13V11C6 10.4477 6.44772 10 7 10Z'
        />
        <path fillRule='evenodd' clipRule='evenodd' d='M15 29V22H17V29H15Z' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11 28C11 27.4477 11.4477 27 12 27L20 27C20.5523 27 21 27.4477 21 28C21 28.5523 20.5523 29 20 29L12 29C11.4477 29 11 28.5523 11 28Z'
        />
      </svg>
    </span>
  );
}

export default RecordingIcon;
